import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { goToInstructionsPage, goToNextPage } from "./actions";
export const template = {
    layout: {
        id: ROUTE.ASK_MUTUAL_FUND_OLD,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "containerStack", type: WIDGET.STACK },
            { id: "continueButton", type: WIDGET.BUTTON, position: POSITION.ABSOLUTE_BOTTOM }
        ],
    },
    datastore: {
        questionText: {
            label: 'Do you have investments in mutual funds?',
            fontWeight: '700',
            fontSize: FontSizeTokens.XL,
            lineHeight: 28,
            paddingLeft: 6,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins
        },
        containerStack: {
            type: StackType.column,
            width: StackWidth.FULL,
            padding: {
                left: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "questionText", type: WIDGET.TEXT },
                { id: "spaceXXXL", type: WIDGET.SPACE },
                { id: "spaceLG", type: WIDGET.SPACE },
                { id: "yesAndNoStack", type: WIDGET.STACK },
            ]
        },
        yesAndNoStack: {
            type: StackType.row,
            width: StackWidth.FULL,
            flex: 1,
            justifyContent: StackJustifyContent.flexStart,
            padding: {
                right: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: "noStack", type: WIDGET.STACK },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "yesStack", type: WIDGET.STACK }
            ]
        },
        yesStack: {
            type: StackType.column,
            flex: 1,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.XS
                }
            },
            padding: {
                bottom: SizeTypeTokens.XXXL,
                top: SizeTypeTokens.XXXL,
                left: SizeTypeTokens.XXXXXXL,
                right: SizeTypeTokens.XXXXXXL
            },
            action: {
                type: ACTION.GO_TO_INSTRUCTIONS_PAGE,
                routeId: ROUTE.ASK_MUTUAL_FUND_OLD,
                payload: {
                    value: "yesMutualFund",
                },
            },
            widgetItems: [
                { id: "yesText", type: WIDGET.TEXT },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "yesImage", type: WIDGET.ICON }
            ]
        },
        noStack: {
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderColor: ColorTokens.Grey_Chalk,
                borderWidth: {
                    all: SizeTypeTokens.XS
                }
            },
            padding: {
                bottom: SizeTypeTokens.XXXL,
                top: SizeTypeTokens.XXXL,
                left: SizeTypeTokens.XXXXXL,
                right: SizeTypeTokens.XXXXXL
            },
            action: {
                type: ACTION.GO_TO_INSTRUCTIONS_PAGE,
                routeId: ROUTE.ASK_MUTUAL_FUND_OLD,
                payload: {
                    value: "noMutualFund",
                },
            },
            widgetItems: [
                { id: "noText", type: WIDGET.TEXT },
                { id: "spaceXL", type: WIDGET.SPACE },
                { id: "noImage", type: WIDGET.ICON }
            ]
        },
        yesText: {
            label: 'Yes',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Poppins,
            color: ColorTokens.Grey_Night
        },
        noText: {
            label: 'No',
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Poppins,
            color: ColorTokens.Grey_Night
        },
        yesImage: {
            name: IconTokens.YesMutualFundDefault,
            size: IconSizeTokens.SM,
        },
        noImage: {
            name: IconTokens.NoMutualFundDefault,
            size: IconSizeTokens.XS,
        },
        spaceLG: {
            size: SizeTypeTokens.LG
        },
        spaceXL: {
            size: SizeTypeTokens.XL
        },
        spaceXXXL: {
            size: SizeTypeTokens.XXXL
        },
        continueButton: {
            label: "Continue",
            fontFamily: FontFamilyTokens.Inter,
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.LargeOutline,
            action: {
                type: ACTION.GO_TO_NEXT_PAGE,
                routeId: ROUTE.ASK_MUTUAL_FUND_OLD
            }
        },
    },
};
export const askMutualFundOldMf = {
    onLoad: async () => {
        return Promise.resolve(template);
    },
    actions: {
        [ACTION.GO_TO_INSTRUCTIONS_PAGE]: goToInstructionsPage,
        [ACTION.GO_TO_NEXT_PAGE]: goToNextPage,
    },
};
